import {yupResolver} from "@hookform/resolvers/yup";
import React from "react";
import {FieldErrors, FormProvider, useForm} from "react-hook-form";
import * as Yup from "yup";

import {SelectField} from "@/components/form/fields/SelectField/SelectField.tsx";
import FormErrorAlerts from "@/components/form/FormErrorAlerts.tsx";
import ServiceSelect from "@/components/serviceSelect/ServiceSelect.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {AddToGroupCheckFormValues} from "@/pages/checks/list/actions/bulkAddToGroupCheck/BulkAddToGroupCheckModal.tsx";

export interface BulkAddToGroupCheckProps {
  formId: string;
  onSubmit: (data: AddToGroupCheckFormValues) => void;
  onError?: (errors: FieldErrors<AddToGroupCheckFormValues>, event?: React.BaseSyntheticEvent) => void;
  serverErrors?: ServerErrors;
}

const BulkAddToGroupCheckFormSchema = Yup.object({
  group_check_id: Yup.number()
    .typeError("You must select a Group Check.")
    .required("You must select a Group Check.")
    .defined("You must select a Group Check."),
});

export const BulkAddToGroupCheckForm = ({formId, onSubmit, onError, serverErrors}: BulkAddToGroupCheckProps) => {
  const methods = useForm<AddToGroupCheckFormValues>({
    resolver: yupResolver<AddToGroupCheckFormValues>(BulkAddToGroupCheckFormSchema),
    mode: "onSubmit",
  });

  return (
    <FormProvider {...methods}>
      <form
        id={formId}
        onSubmit={(e) => {
          methods.handleSubmit(onSubmit, onError)(e);
        }}
      >
        {serverErrors?.group_check_id && <FormErrorAlerts errors={serverErrors.group_check_id} />}
        <div className="row mb-4">
          <div className="col fst-italic">
            Note: The selected Checks, excluding Group Checks, will be added to whichever Group you create or select
            below.
          </div>
        </div>
        <SelectField
          name={"group_check_id"}
          label="Add to Group Check"
          isSearchable
          required
          placeholder={"Select Group Check..."}
          menuPortalTarget={
            (document.querySelector(`div.outlet-container > div.content-container`) as HTMLElement) ?? document.body
          }
          menuPosition={"fixed"}
          select={
            <ServiceSelect
              placeholder="Select Group Check..."
              serviceType={"GROUP"}
              isSearchable
              onChange={(selectedOption) => {
                methods.setValue("group_check_id", selectedOption?.id);
              }}
            />
          }
        />
      </form>
    </FormProvider>
  );
};
